/* eslint-disable */
import get from 'lodash.get';

export const STATE_KEY = 'dealer';
export const getDealersObject = (state) => get(state, [STATE_KEY, 'dealersObject']);
export const getCurrentZipCode = (state) => get(state, [STATE_KEY, 'currentZipCode']);
export const isQuerySuccessful = (state) => get(state, [STATE_KEY, 'querySucceeded']);
export const isQuerying = (state) => get(state, [STATE_KEY, 'querying']);
export const getQueryResponse = (state) => get(state, [STATE_KEY, 'response']);
export const getQuery = (state) => get(state, [STATE_KEY, 'query']);
export const getQueryErrorObject = (state) => get(state, [STATE_KEY, 'error']);
export const didQueryFail = (state) => get(state, [STATE_KEY, 'queryFailed']);

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/dealers.js
 **/